import React from 'react'
import styles from './styles.module.css'
import Arrow from '../../components/arrow'
import Line from '../../components/line'
import { Tooltip } from 'antd'
import CKDPatientTooltip from './components/CKDPatientTooltip'
import ClinicalData from './components/clinicalData'
import CKDCode from './components/CKDCode'

function Operation(props) {
  return (
    <div className={styles.zhyl_ckd_operation}>
      <div className={styles.zhyl_ckd_operation_process}>
        {/* <Arrow direction='right' />
        <Line /> */}
        <div className={styles.zhyl_ckd_operation_process_top}>
          <Tooltip title={<ClinicalData />} color='#E8EFF3' placement='right'>
            <a>
              <div className={styles.zhyl_ckd_operation_process_top1}>
                <p
                  className={styles.zhyl_ckd_operation_process_top1_txt1}
                  style={{ marginBottom: '8px' }}
                >
                  真实世界医疗数据
                </p>
                <p className={styles.zhyl_ckd_operation_process_top1_txt2}>
                  临床资料
                </p>
              </div>
            </a>
          </Tooltip>

          <Arrow direction='right' width={80} style={{ marginTop: '35px' }} />
          <Tooltip title={<CKDCode />} color='#E8EFF3' placement='right'>
            <a>
              <div className={styles.zhyl_ckd_operation_process_top2}>
                <p
                  className={styles.zhyl_ckd_operation_process_top1_txt1}
                  style={{ marginBottom: '8px' }}
                >
                  命名实体识别
                </p>
                <p className={styles.zhyl_ckd_operation_process_top1_txt2}>
                  CKD相关诊断及ICD编码
                </p>
              </div>
            </a>
          </Tooltip>

          <Line width={55} style={{ marginTop: '38px' }} />
        </div>
        <div className={styles.zhyl_ckd_operation_process_mid}>
          <p
            className={styles.zhyl_ckd_operation_process_mid_top_text}
            style={{
              // marginTop: '8px',
              marginLeft: '12px'
            }}
          >
            数值型特型提取
          </p>
          <p
            className={styles.zhyl_ckd_operation_process_mid_top_text2}
            style={{
              marginTop: '8px'
            }}
          >
            CKD相关实验室检查+时间戳
          </p>
          <div className={styles.zhyl_ckd_operation_process_mid_top_line}>
            <div className={styles.zhyl_ckd_operation_process_mid_top_line_col}>
              <Line direction='col' width={8} />
              <Line direction='col' width={16} />
              <Line direction='col' width={8} />
            </div>
            <Line
              width={238}
              style={{
                position: 'absolute',
                top: '7px'
              }}
            />
          </div>
          <div className={styles.zhyl_ckd_operation_process_mid_top_bottom_col}>
            <p
              className={
                styles.zhyl_ckd_operation_process_mid_top_bottom_col_text
              }
              style={{ marginLeft: '24px' }}
            >
              正常结果
            </p>
            <p
              className={
                styles.zhyl_ckd_operation_process_mid_top_bottom_col_text
              }
              style={{ marginLeft: '62px' }}
            >
              <p>单次检验异常</p>
              <p>OR≤3个月</p>
            </p>
            <p
              className={
                styles.zhyl_ckd_operation_process_mid_top_bottom_col_text
              }
              style={{ marginLeft: '54px' }}
            >
              <p>双次检验异常</p>
              <p>AND>3个月</p>
            </p>
          </div>
          <Arrow
            direction='left'
            width={149}
            style={{ position: 'absolute', top: '36px', right: '-55px' }}
          />
        </div>
        <div className={styles.zhyl_ckd_operation_process_bottom}>
          <div className={styles.zhyl_ckd_operation_process_bottom1}>
            <Arrow direction='bottom' width={28} />
            <div className={styles.zhyl_ckd_operation_process_bottom1_text}>
              <p>非CKD患者</p>
            </div>
          </div>
          <div
            className={styles.zhyl_ckd_operation_process_bottom2}
            style={{ width: '100px', marginLeft: '43px' }}
          >
            <div className={styles.zhyl_ckd_operation_process_bottom1}>
              <Arrow direction='bottom' width={28} />
              <div
                className={styles.zhyl_ckd_operation_process_bottom1_text}
                style={{ width: '100px' }}
              >
                <p>CKD高危人群</p>
              </div>
            </div>
          </div>
          <div className={styles.zhyl_ckd_operation_process_bottom3}>
            <div
              className={styles.zhyl_ckd_operation_process_bottom1}
              style={{ width: '75px', marginLeft: '31px' }}
            >
              <Arrow direction='bottom' width={28} />
              <Tooltip
                title={<CKDPatientTooltip />}
                color='#E8EFF3'
                placement='right'
              >
                <a>
                  <div
                    className={styles.zhyl_ckd_operation_process_bottom1_text1}
                    style={{ width: '75px' }}
                  >
                    <p>CKD患者</p>
                  </div>
                </a>
              </Tooltip>
            </div>
          </div>
          <Arrow direction='left' width={80} style={{ marginTop: '35px' }} />
        </div>
      </div>
      <Line direction='col' width={209} style={{ marginTop: '62px' }} />
      <div className={styles.zhyl_ckd_operation_text}>
        <div className={styles.zhyl_ckd_operation_text_top}>
          <p
            className={styles.zhyl_ckd_operation_text_top_title}
            style={{ marginBottom: '12px' }}
          >
            操作流程
          </p>
          <p className={styles.zhyl_ckd_operation_text_top_text}>
            <span className={styles.zhyl_ckd_operation_text_top_point} />
            点击“获取模板”将Excel文件下载到本地。
          </p>
          <p className={styles.zhyl_ckd_operation_text_top_text}>
            <span className={styles.zhyl_ckd_operation_text_top_point} />
            根据模板格式对数据进行预处理，统一实验室校验数据单位、日期格式。
          </p>
          <p className={styles.zhyl_ckd_operation_text_top_text}>
            <span className={styles.zhyl_ckd_operation_text_top_point} />
            导入表格，系统会先校验数据完整性，再进行计算。
          </p>
          <p className={styles.zhyl_ckd_operation_text_top_text}>
            <span className={styles.zhyl_ckd_operation_text_top_point} />
            导出文件，计算结果将以新增列的方式添加到原有数据列的右侧。
          </p>
        </div>
        <div
          className={styles.zhyl_ckd_operation_text_bottom}
          style={{ marginTop: '24px' }}
        >
          <div
            className={styles.zhyl_ckd_operation_text_bottom_title}
            style={{ marginBottom: '12px' }}
          >
            <span style={{ color: '#FF6A6A' }}>*</span>
            <p className={styles.zhyl_ckd_operation_text_top_title}>说明</p>
          </div>
          <p className={styles.zhyl_ckd_operation_text_top_text}>
            1、数据需匿名化处理
          </p>
          <p className={styles.zhyl_ckd_operation_text_top_text}>
            2、实验室检验数据单位、日期格式需与表格示例一致
          </p>
          <p className={styles.zhyl_ckd_operation_text_top_text}>
            3、一名患者一行数据。若该患者有多个检查结果，则通过新增列实现
          </p>
        </div>
      </div>
    </div>
  )
}

export default Operation
